<section class="cicd-executions h-100">
	<header class="cicd-header">
		<div class="selection-summary">
			<label class="select-all-wrap" for="select-all-cicd">
				<input
					id="select-all-cicd"
					class="select-all-checkbox"
					type="checkbox"
					[checked]="allSelected"
					(change)="onSelectAllChange($event)"
				/>
				<span class="select-all-text">Select all</span>
			</label>

			<span class="range-label">{{ rangeLabel }}</span>
		</div>

		<div class="header-actions">
			<button type="button" class="btn-accello-secondary header-btn" (click)="addNewCICDExecution()">
				<img class="btn-icon" src="assets/images/virtusa-icons/insert-row.svg" alt="Add" aria-hidden="true" />
				<span class="btn-lable">Add New CI/CD Executions</span>
			</button>

			<button
				type="button"
				class="btn-accello-secondary header-btn"
				(click)="removeCICDExecution()"
				[disabled]="!hasSelection || isRemoving"
			>
				<span *ngIf="isRemoving" class="cicd-btn-spinner"></span>
				<img *ngIf="!isRemoving" class="btn-icon" src="assets/images/virtusa-icons/delete-row.svg" alt="Remove" aria-hidden="true" />
				<span class="btn-lable">{{ isRemoving ? 'Removing...' : 'Remove CI/CD Execution' }}</span>
			</button>
		</div>
	</header>

	<div class="cicd-table-body">
		<!-- Loading spinner -->
		<div *ngIf="isLoading" class="cicd-loading-wrap">
			<div class="cicd-spinner"></div>
		</div>

		<app-zorro-table
			*ngIf="!isLoading"
			[columns]="columns"
			[data]="executions"
			tableId="cicd-executions-table"
			[options]="tableOptions"
			(onRowSelect)="onRowSelectChange($event)"
			(handleActions)="onTableAction($event)"
			(pageChange)="onTablePageChange($event)"
		></app-zorro-table>
	</div>
</section>
